import {Component, OnInit, OnDestroy, ElementRef, Output, EventEmitter, Input} from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExportToCsv } from 'export-to-csv';

import {Package, CDSNode, Rule, RuleSet} from '../services/capd.model';
import { PackageService } from '../services/package.service';
import { OrgService } from '../services/org.service';
import {OrgDataService} from "../services/org-data.service";
import {TenantMappingsComponent} from "../cds_tenant_mapping/tenant_mappings_org.component";
import {AlertService} from "../services/alert.service";

declare var $: any;
export let duplicatesArray: any =[];
@Component({
  templateUrl: './company.component.html',
})

/**
 * The main host component for company-level content viewing.
 */
export class CompanyContentComponent implements OnInit, OnDestroy {
  root: string;
  scope: string;
  loadInit: boolean = true;
  org: CDSNode;
  orgPacks: Package[];
  watermarkText;
  csvData: any = [];
  exporting = false;
  selectedPack: Package;
  private sub: any;

  isDisabled = true;
  update = new EventEmitter();
  package: Package;

  packList: Package[];
  toAdd: {contentPackage_id: string};

  packUpdate: EventEmitter<any> = new EventEmitter();
  oldPak: Package;
  newVer: string;
  newRuleset: RuleSet;

  altered: Rule[] = [];
  selectedRule: Rule;
  oldSelectedRule: Rule = null;
  op: string;
  canEditOrg: boolean = true;
  orgInTreeRoots: boolean = false;

  constructor(private _packs: PackageService,
              private _service: OrgService,
              private _route: ActivatedRoute,
              private _sanitize: DomSanitizer,
              private _el: ElementRef,
              private _orgDataService: OrgDataService,
              private _tenantMappingsComponent: TenantMappingsComponent,
              private alertService: AlertService) { }

/**
 * The initializer finds the current OID of the organization and loads the packages as necessary.
 *
 * @async
 * @func ngOnInit
 */
  ngOnInit() {
    sessionStorage.removeItem('alerts');
    this.scope = sessionStorage.getItem('scope');
    this.sub = this._route.params.subscribe(params => this.root = params.id);
    this.org = this._orgDataService.currentOrg
    this.doUpdate();
  }

  getPackageList() {
    this._service.getUnassignedOrgPackages(this.org.rootId)
        .then((packs: Package[]) => this.packList = packs);
  }

  /**
   * Searches the package for any rules that have been modified, and updates the package modified value if so
   *
   * @func updateModified
   * @param {Package} pack - The package to search for modified rules in
   */
  updateModified(pack: Package) {
    let packModified = false;
    if (pack && pack.packageRules) {
      pack.packageRules.forEach(rule => {
        if (rule.modified) {
          packModified = true;
        }
      });
    }
    pack.modified = packModified;
  }

/**
 * Bread-and-butter function that gets called by any fuctions that make changes to the displayed packages.
 * It updates the main view of the page.
 *
 * @async
 * @func doUpdate
 * @param {any} packArg - an optional arguement.  Usually passed in whenever a new package has been added
 *                        or an existing package has been updated.  It pushes new rules to the top and
 *                        automatically selects the new package.
 */
  async doUpdate(packArg?) {
    this.updateCanEdit();
    this.loadInit = true;
    this.watermarkText = '<span>Loading...<br /><img src="./app/css/img/linear-loader.gif" alt=""/></span>';
    if(!packArg) {
        this.org = this._orgDataService.currentOrg

        this._service.getUnassignedOrgPackages(this._orgDataService.currentOrg.rootId)
            .then((packs: Package[]) => this.packList = packs);

        this._service.getOrgPackagesAndRules(this._orgDataService.currentOrg).then((packageList: Package[]) => {
          if(packageList !== null) {
            this.orgPacks = packageList
            this.orgPacks.forEach(pack => {
              this.updateModified(pack);
              //@ts-ignore
              pack.version = pack.version.major + "." + pack.version.minor + "." + pack.version.build
            })
          }

          if (packageList == null || this.orgPacks.length <= 0) {
            if (this.scope === 'UserManager') {
              this.watermarkText = this._sanitize.sanitize(SecurityContext.HTML,
                  `<span>This customer currently has no packages.</span><br />
                  <a type="button" data-toggle="modal" data-target="#modal-assign-package">Add a package...</a>`);
              this.loadInit = false;
            } else {
              this.watermarkText = '<span>Packages cannot be assigned for this customer.</span>';
              this.loadInit = false;
            }
          } else {
            this.orgPacks.sort((a, b) => a.name.localeCompare(b.name));
            if (!packArg) {
              this.selectedPack = this.orgPacks[0];
            }
          }
          if(this.selectedPack) {
            this.oldPak = this.selectedPack;
            this.createCsv();
          }

        })
    }
    else {

      this.org = this._orgDataService.currentOrg

        this._service.getUnassignedOrgPackages(this._orgDataService.currentOrg.rootId)
            .then((packs: Package[]) => {
              this.packList = packs;

              this._service.getOrgPackagesAndRules(this._orgDataService.currentOrg).then((packageList: Package[]) => {

                this.orgPacks = packageList
                if (this.orgPacks != null) {
                  this.orgPacks.forEach(pack => {

                    this.updateModified(pack);
                    //@ts-ignore
                    pack.version = pack.version.major + "." + pack.version.minor + "." + pack.version.build

                    if (pack.name == packArg.name) {
                      pack.newRules = []
                      let oldRules = []
                      pack.packageRules.forEach(rule => {
                        if (packArg.packageRules.findIndex((r) => r.triggerCode === rule.triggerCode) < 0)
                          pack.newRules.push(rule)
                        else
                          oldRules.push(rule)
                      })
                      pack.packageRules = oldRules
                      this.selectedPack = pack
                    }

                    if (pack.id == packArg.id) {
                      setTimeout(() => {
                        this.onSelect(pack)
                      },500);
                    }

                  })
                }

                if (this.orgPacks == null || this.orgPacks.length <= 0) {
                  if (this.scope === 'UserManager') {
                    this.watermarkText = this._sanitize.sanitize(SecurityContext.HTML,
                        `<span>This customer currently has no packages.</span><br />
                  <a type="button" data-toggle="modal" data-target="#modal-assign-package">Add a package...</a>`);
                    this.loadInit = false;
                  } else {
                    this.watermarkText = '<span>There are no packages to display.</span>';
                    this.loadInit = false;
                  }
                } else {
                  this.orgPacks.sort((a, b) => a.name.localeCompare(b.name));
                  if (!packArg) {
                    this.selectedPack = this.orgPacks[0];
                    this.updateModified(this.selectedPack);
                  }
                }

                this.oldPak = this.selectedPack;
                this.createCsv();

              }).then(() => {
                setTimeout(() => {
                  this.selectedPack = this.orgPacks.filter(x => x.id == packArg.contentPackage_id)[0];
                  this.updateModified(this.selectedPack);
                  $(".list-group-item.active")[0].scrollIntoView();
                }, 1);
              })
            });
    }

    this.toAdd = null;

  this._tenantMappingsComponent.expandedRoot = this.org.rootId.replace('~', '2.16.840.1.113883.3.21');
  this._tenantMappingsComponent.loadMapping().then(result => {
    if (this.oldPak && this.oldPak.packageRules) {
      this.oldPak.packageRules = this.oldPak.packageRules.filter(rule => {
        return this._packs.shouldRuleDisplayBasedOnTenant(rule, this._tenantMappingsComponent.thisMapping.tenant);
      });
    }
    if (this.selectedPack && this.selectedPack.packageRules) {
      this.selectedPack.packageRules = this.selectedPack.packageRules.filter(rule => {
        return this._packs.shouldRuleDisplayBasedOnTenant(rule, this._tenantMappingsComponent.thisMapping.tenant);
      });
    }
  });
  }

  /**
   * When the user wants to update a new package, this shows the confirmation modal.
   *
   * @func onUpdate
   * @param {Package} pack - the package that needs updating.
   */
  onUpdate(pack: Package) {
    this.selectedPack = pack;
    this.updateModified(this.selectedPack);
    this.oldPak = pack;
    $(this._el.nativeElement).find('#modal-package-review').toggle('show');
  }

  /**
   * Creates a CSV file with data relevant to content providers and marketing teams.
   *
   * @func createCsv
   */
  createCsv() {
    this.exporting = true;
    this.csvData = [];
    let processed = 0;
    this.orgPacks.forEach(pack => {
      if(pack.packageRules) {
        if(pack.modified) {
          this._packs.getRuleset(pack.id).then((packRules: Rule[]) => {
            pack.packageRules.forEach(rule => {
              if(rule.action.messageTitle == undefined)
                rule.action.messageTitle = rule.triggerName

              let matchedRule = packRules.filter(x => rule.triggerCode == x.triggerCode)
              if(matchedRule) {
                matchedRule.forEach((match: Rule) => {
                  let modifiedMessageTitle = "FALSE"
                  let modifiedProviderMessage = "FALSE"
                  let modified = "FALSE"

                  if(match.action.messageTitle != rule.action.messageTitle)
                    modifiedMessageTitle = "TRUE"
                  if(match.action.messageText != rule.action.messageText)
                    modifiedProviderMessage = "TRUE"
                  if(modifiedProviderMessage == "TRUE" && modifiedMessageTitle == "TRUE")
                    modified = "both"
                  else if(modifiedProviderMessage == "TRUE")
                    modified = "providerMessage"
                  else if(modifiedMessageTitle == "TRUE")
                    modified = "messageTitle"


                  const csvRule = {
                    'Package Name': pack.name + ' ' + pack.version,
                    Modified: modified,
                    'Modified Message Title': modifiedMessageTitle,
                    'Modified Provider Message': modifiedProviderMessage,
                    'Rule Name': rule.action.messageTitle,
                    Triggercode: rule.triggerCode,
                    //@ts-ignore
                    Groups: String(rule.groupNames.filter(r => { return r !== null; }))
                  };
                  this.csvData.push(csvRule)
                })
              } else {
                const csvRule = {
                  'Package Name': pack.name + ' ' + pack.version,
                  Modified: "FALSE",
                  'Modified Message Title': "FALSE",
                  'Modified Provider Message': "FALSE",
                  'Rule Name': rule.action.messageTitle,
                  Triggercode: rule.triggerCode,
                  //@ts-ignore
                  Groups: String(rule.groupNames.filter(r => { return r !== null; }))
                };
                this.csvData.push(csvRule)
              }
            })
          })
        } else {
      //@ts-ignore
      pack.packageRules.forEach(rule => {
        if(rule.action.messageTitle == undefined)
          rule.action.messageTitle = rule.triggerName

        const csvRule = {
          'Package Name': pack.name + ' ' + pack.version,
          Modified: "FALSE",
          'Modified Message Title': "FALSE",
          'Modified Provider Message': "FALSE",
          'Rule Name': rule.action.messageTitle,
          Triggercode: rule.triggerCode,
          //@ts-ignore
          Groups: String(rule.groupNames.filter(r => { return r !== null; }))
        };
        this.csvData.push(csvRule)
      })
    }
      }
      processed++;
      if(processed === this.orgPacks.length) {this.exporting = false}
    })

  }

  /**
   * Changes the flag to show that a package has been modified.\
   *
   * @func isModified
   */
  isModified() {
    this.doUpdate(this.selectedPack);
  }

  noSelected() {
    this.selectedPack = null;
  }

  /**
   * Selects a new package.
   *
   * @func onSelect
   */
  onSelect(pack: Package) {
    let previousPackOrgId = sessionStorage.getItem('packorgid');
    if (previousPackOrgId && previousPackOrgId != pack.id + this.org.rootId + this.org.extensionId) {
      sessionStorage.removeItem('alerts');
    }
    if (pack && pack.packageRules) {
      pack.packageRules = pack.packageRules.filter(rule => {
        return this._packs.shouldRuleDisplayBasedOnTenant(rule, this._packs.tenant);
      });
    }
    this.selectedPack = pack;
    this.updateModified(this.selectedPack);
    this.oldPak = pack;
    this.newVer = this.oldPak.upgradeVersion;
    this._packs.reviewPackageUpdate(this.oldPak).then((rules: RuleSet) => this.newRuleset = rules);
  }

  showAddModal() {
    $(this._el.nativeElement).find('#modal-assign-package').show();
  }

  /**
   * Disposes of the subscriber event.
   *
   * @func ngOnDestroy
   */
  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  /**
   * At a user's request, this creates a downloadable .csv
   * file with the aforementioned data.
   *
   * @func exportCsv
   */
  exportCsv() {
    const options = {
      filename: this.org.description + '_' + Date.now(),
      fieldSeparator: ',',
      quoteStrings: '"',
      decimalSeparator: '.',
      showLabels: true,
      showTitle: true,
      title: 'Company Package Export CSV',
      useKeysAsHeaders: false,
      headers: ['Package Name', 'Modified', 'Modified Message Title', 'Modified Provider Message', 'Rule Name', 'Triggercode', 'Groups'],
      useTextFile: false,
      useBom: true
    };

    const csvExporter = new ExportToCsv(options);

    if(!(this.csvData === undefined) && this.csvData !== null) {
      csvExporter.generateCsv(this.csvData);
    } else {
      this.alertService.showAlert("Invalid Export. No data provided.");
    }
  }

  /**
   * Toggle checkbox that disables the delete button by default.
   *
   * @func toggleDisabled
   */
  toggleDisabled() {
    this.isDisabled = !this.isDisabled;
  }

  /**
   * Removes the package assignment from the company/org.
   *
   * @async
   * @func onDelete
   */
  onDelete() {
    this._service.removePackageFromOrg(this.selectedPack.id, this.org.rootId).then(() => {
      this.update.emit(null);
      this.doUpdate();
    });
  }

  showDeleteModal() {
    $(this._el.nativeElement).find('#modal-delete-pack').show();
  }

  hideDeleteModal() {
    $(this._el.nativeElement).find('#modal-delete-pack').hide();
  }

  /**
   * Change the currently selected package
   *
   * @func updateChecked
   * @param {any} option - a content package ID to add to the org.
   */
  updateChecked(option) {
    this.toAdd = option;
  }

  /**
   * When you cancel to dismiss the modal, clear the current package to add.
   *
   * @func onCancel
   */
  onCancel() {
    this.toAdd = null;
    $(this._el.nativeElement).find('#modal-assign-package').hide();
  }

  /**
   * Confirms the assignment of a package to an org, and updates the tables accordingly.
   *
   * @async
   * @func onSubmit
   */
  async onSubmit() {
    await this._service.pullPackageToOrg(this.toAdd, this.org.rootId).then(() => {
      const emit = this.toAdd;
      this.update.emit(emit);
    });

    $(this._el.nativeElement).find('#modal-assign-package').hide();
    this.doUpdate(this.toAdd);
  }

  selectRule(rule, newOp: string) {
    this.op = newOp;
    if (newOp === 'c') {
      this.selectedRule = rule.to;
      this.oldSelectedRule = rule.from;
    }
    else {
      this.selectedRule = rule;
      this.oldSelectedRule = this.selectedRule;
    }
  }

  onConfirm() {
    const newVer = this.oldPak.id.replace(/-([^-]*)$/, '-' + this.oldPak.upgradeVersion);
    this._packs.updatePackage(this.oldPak, this.org).then(res => {
      this.packUpdate.emit({version: newVer, newRules: this.newRuleset.addedRules});
      $(this._el.nativeElement).find('#modal-package-review').hide();
      duplicatesArray = this.newRuleset.addedRules;
      this.doUpdate(this.oldPak);
    }).catch(err => {
          this.packUpdate.emit({version: newVer, newRules: this.newRuleset.addedRules});
          $(this._el.nativeElement).find('#modal-package-review').hide();
          duplicatesArray = this.newRuleset.addedRules;

    });
  }

  closePackageReview() {
    $('#modal-package-review').hide();
  }

  updateCanEdit() {
    let idEnd = this.root.replace('~', '2.16.840.1.113883.3.21').split('.').pop();
    let parentId = this.root.replace('~', '2.16.840.1.113883.3.21').replace('.' + idEnd, '');
    let treeRoots: string[] = sessionStorage.getItem('treeRoots').split(',');
    let parentIdIncludedInTreeRoots = treeRoots.indexOf(parentId) > -1;

    if (this.org == undefined) {

      this._service.getOrg(this.root).then((res: CDSNode) => {
        let companyExtensionCheck = res.extensionId.includes('Company');
        this.canEditOrg = companyExtensionCheck || parentIdIncludedInTreeRoots;
        this.orgInTreeRoots = treeRoots.indexOf(parentId + res.rootId.replace('~', '')) > -1;

        this.org = res;
        this._orgDataService.setCurrentOrg(res);
        this.doUpdate();
      });

    } else {

      let companyExtensionCheck = this.org.extensionId.includes('Company');
      this.canEditOrg = companyExtensionCheck || parentIdIncludedInTreeRoots;
      this.orgInTreeRoots = treeRoots.indexOf(parentId + this.org.rootId.replace('~', '')) > -1;

    }
  }
}
